import Lang from '@/modules/core/app/services/Lang';
import { FormSelectConfig } from '@/modules/core/form/models/FormSelectConfig';
import { GenericModel } from '@/modules/core/app/models/GenericModel';
import WorkflowGuidanceStepListService from '@/modules/workflow/services/WorkflowGuidanceStepListService';

export class WorkflowGuidanceStepFormSelectConfig extends FormSelectConfig {
  constructor(config: Params = {}) {
    super({
      placeholder: Lang.t('core.select'),
      ...config
    });
  }

  // @ts-ignore
  async getOptions(
    params: { selectedJurisdictions: Array<number>; selectedEstateTypes: Array<string> } = {
      selectedJurisdictions: [],
      selectedEstateTypes: []
    }
  ): Promise<GenericModel[]> {
    return WorkflowGuidanceStepListService.getGuidanceStepList(
      params.selectedJurisdictions,
      params.selectedEstateTypes
    );
  }
}
